export const iconFontAwesomeHandsHandsHoldingChild = (
	<i className="fa-solid fa-hands-holding-child"></i>
);
